import React, { useState } from "react";
import * as Yup from "yup";
import "./join-us.css";
import { useNavigate } from "react-router-dom";



export const useSecondViewHook = () => {
     const navigate = useNavigate();
      const [showPassword, setShowPassword] = useState(false);
       const [showConfirmPassword, setShowConfirmPassword] = useState(false);
       
       const validationSchema = Yup.object({
         firstName: Yup.string().required("First name is required."),
         lastName: Yup.string().required("Last name is required."),
        password: Yup.string()
        .min(6, "Password must be at least 6 characters")
          .required("Password is required."),
        confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
          .required("Confirm password is required."),
          phone: Yup.string()
          .required("Phone number is required."),
          address: Yup.string().required("Address is required."),
          country: Yup.string().required("Country is required."),
          city: Yup.string().required("City is required."),
          zip: Yup.string()
          .matches(/^\d{5}$/, "Zip code must be 5 digits.")
          .required("Zip code is required."),
        });
        
        const togglePasswordVisibility = () => {
          setShowPassword(!showPassword);
        };
        
        const toggleConfirmPasswordVisibility = () => {
          setShowConfirmPassword(!showConfirmPassword);
        };
    
        const handleNavigate = () => {
          navigate("/");
        }
    
    return{
        showPassword,
        showConfirmPassword,
        setShowPassword,
        setShowConfirmPassword,
        validationSchema,
        togglePasswordVisibility,
        toggleConfirmPasswordVisibility,
        handleNavigate
    };
}